"use strict";

exports._ = require("tslib").__decorate;
